import { PlotterMode } from 'business/data-analysis/constants';
import { UseFilters } from 'business/data-analysis/pages/graph/components/filter-card/hooks/use-filters';

export const isFetchingDisabled = ({
  isFetching,
  atLeastOneParameterIsSelected,
  filters,
  mode,
}: {
  isFetching: boolean;
  atLeastOneParameterIsSelected: boolean;
  filters: ReturnType<UseFilters>['filters'];
  mode: PlotterMode;
}) => {
  if (isFetching) {
    return true;
  }

  if (!atLeastOneParameterIsSelected) {
    return true;
  }

  if (
    mode === PlotterMode.RING &&
    (!filters.ringFilters ||
      filters.ringFilters?.[0] === null ||
      filters.ringFilters?.[1] === null)
  ) {
    return true;
  }

  return false;
};
